import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export type BreadcrumbItem = {
    label: string;
    to?: string;
};

type Props = {
    items: BreadcrumbItem[];
    showHome?: boolean;
};

const styles = {
    nav: {
        fontSize: '0.95rem',
        color: '#6c757d',
    } as React.CSSProperties,
    list: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: '0.5rem',
        margin: 0,
        padding: 0,
        listStyle: 'none',
    } as React.CSSProperties,
    link: {
        color: '#007bff',
        textDecoration: 'none',
    } as React.CSSProperties,
    separator: {
        color: '#adb5bd',
    } as React.CSSProperties,
    current: {
        color: '#495057',
        fontWeight: 500,
    } as React.CSSProperties,
};

const Breadcrumb: React.FC<Props> = ({ items, showHome = true }) => {
    const { t } = useTranslation();
    const allItems: BreadcrumbItem[] = showHome
        ? [{ label: t('nav.home'), to: '/' }, ...items]
        : items;

    return (
        <nav aria-label="breadcrumb" style={styles.nav}>
            <ol style={styles.list}>
                {allItems.map((item, idx) => {
                    const isLast = idx === allItems.length - 1;
                    return (
                        <React.Fragment key={idx}>
                            <li>
                                {item.to && !isLast ? (
                                    <Link to={item.to} style={styles.link}>
                                        {item.label}
                                    </Link>
                                ) : (
                                    <span style={styles.current}>{item.label}</span>
                                )}
                            </li>
                            {!isLast && <li style={styles.separator}>›</li>}
                        </React.Fragment>
                    );
                })}
            </ol>
        </nav>
    );
};

export default Breadcrumb;
